import React from 'react';
import { Button, ButtonProps } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';
import { useFileTemporaryLinkMutation } from 'src/data-capture/hooks/useFileTemporaryLinkMutation';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';

type Props = {
  fileId: number;
} & ButtonProps;

export function DownloadFileButton(props: Props) {
  const { createLink, isLoading: isCreatingLink } = useFileTemporaryLinkMutation();

  const handleDownload = async (templatisedFileId: number) => {
    try {
      const link = await createLink(templatisedFileId);
      window.open(link.url, '_blank');
    } catch (e) {
      notifyAndLogError(
        'Failed to download meeting note',
        'An error occurred while trying to download the meeting note. Please try again later.',
        e,
        { templatisedFileId },
      );
      return;
    }
  };

  return (
    <Button
      variant="subtle"
      onClick={() => handleDownload(props.fileId)}
      leftSection={<IconDownload size={16} />}
      loading={isCreatingLink}
      {...props}
    >
      Download
    </Button>
  );
}
